import React, { useEffect, useState, useCallback } from 'react';
import { Link } from 'react-router-dom';
import { Edit, Trash2, Plus } from 'lucide-react';
import toast from 'react-hot-toast';
import AdminLayout from '../../components/admin/AdminLayout';
import api from '../../utils/api';

export default function AdminServices() {
  const [services, setServices] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  const loadServices = useCallback(() => {
    setLoading(true);
    api.get('/admin/services')
      .then((res) => setServices(res.data))
      .catch(() => setError('Nuk arritëm të ngarkonim shërbimet.'))
      .finally(() => setLoading(false));
  }, []);

  useEffect(() => { loadServices(); }, [loadServices]);

  const handleDelete = async (id) => {
    if (!window.confirm('A jeni të sigurt që doni të fshini këtë shërbim?')) return;
    try {
      await api.delete(`/admin/services/${id}`);
      toast.success('Shërbimi u fshi.');
      loadServices();
    } catch {
      toast.error('Gabim gjatë fshirjes.');
    }
  };

  return (
    <AdminLayout>
      <div className="admin-page-header">
        <div>
          <h1 className="page-title">Shërbimet</h1>
          <p className="admin-page-sub">Lista e shërbimeve në sistemin e administrimit</p>
        </div>
        <Link to="/admin/sherbimet/i-ri" className="btn btn-primary">
          <Plus size={15}/> Shërbim i ri
        </Link>
      </div>

      <div className="card">
        {error && <div className="alert alert-error" style={{ marginBottom: '1rem' }}>{error}</div>}
        {loading ? (
          <div className="spinner" />
        ) : (
          <div className="table-wrap">
            <table>
              <thead>
                <tr>
                  <th>ID</th>
                  <th>Emri</th>
                  <th>Slug</th>
                  <th>Statusi</th>
                  <th>Renditja</th>
                  <th>Veprimet</th>
                </tr>
              </thead>
              <tbody>
                {services.map((service) => (
                  <tr key={service.id}>
                    <td>{service.id}</td>
                    <td>{service.name}</td>
                    <td>{service.slug}</td>
                    <td>{service.is_active ? 'Aktiv' : 'Jo aktiv'}</td>
                    <td>{service.sort_order}</td>
                    <td>
                      <div className="action-btns">
                        <Link to={`/admin/sherbimet/${service.id}/ndrysho`} className="btn btn-secondary btn-sm">
                          <Edit size={13}/>
                        </Link>
                        <button className="btn btn-danger btn-sm" onClick={() => handleDelete(service.id)}>
                          <Trash2 size={13}/>
                        </button>
                      </div>
                    </td>
                  </tr>
                ))}
                {services.length === 0 && (
                  <tr>
                    <td colSpan={6} style={{ textAlign: 'center', color: 'var(--gray-400)', padding: '2rem' }}>
                      Nuk ka shërbime.
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </AdminLayout>
  );
}
